import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/plate_shadow.png';
import rusBg from '../../assets/images/rus_bg.svg';

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
	height: 254px;
	padding: 20px 18px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
	background-image: url(${rusBg});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	overflow: hidden;
`;

const StyledShadow = styled.div`
	position: absolute;
	top: -250px;
	left: 50%;
	transform: translateX(-50%);
	width: 500px;
	height: 500px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	pointer-events: none;
`;

const StyledTopContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;

	${Text} {
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledPlateTypeText = styled(Text)`
	flex: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

const StyledRegionText = styled(Text)`
	flex-shrink: 0;
	white-space: nowrap;
`;

const StyledCenterContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledArrowButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	cursor: pointer;
	transition: background 0.3s ease;
	border-radius: 50%;

	&:hover {
		background: #ffffff;

		img {
			filter: invert(100%);
		}
	}

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}
`;

const StyledBottomContainer = styled.div<{
	$active?: boolean;
	$count?: number;
}>`
	height: ${({ $active }) => ($active ? 30 : 0)}px;
	display: grid;
	grid-template-columns: repeat(${({ $count }) => $count || 2}, 165px);
	justify-content: ${({ $count }) =>
		$count === 2 ? 'space-between' : 'center'};
	transition: height 0.3s ease;
`;

const StyledModerationLabelContainer = styled.div<{ $active?: boolean }>`
	width: 100%;
	height: ${({ $active }) => ($active ? 30 : 0)}px;
	opacity: ${({ $active }) => ($active ? 1 : 0)};
	transition:
		height 0.3s ease,
		opacity 0.3s ease;
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;

	${Text} {
		font-weight: 500;
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledBottomItem = styled.div`
	display: grid;
	grid-template-columns: 30px 1fr;
`;

const StyledPlusContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	background: #1f8034;
	border-radius: 5px 0px 0px 5px;

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledBottomItemTextContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 30px;
	background: rgba(31, 128, 52, 0.25);
	border: 1px solid #1f8034;
	border-radius: 0px 5px 5px 0px;

	${Text} {
		font-weight: 500;
		font-size: 12px;
		color: #ffffff;
	}
`;

export {
	StyledArrowButton,
	StyledBottomContainer,
	StyledBottomItem,
	StyledBottomItemTextContainer,
	StyledCenterContainer,
	StyledContainer,
	StyledModerationLabelContainer,
	StyledPlateTypeText,
	StyledPlusContainer,
	StyledRegionText,
	StyledShadow,
	StyledTopContainer,
};
